import React from 'react';

import withIntl from '../../../shared/intl-hoc';

const isEverad = process.env.CPA_ENV === 'everad';

function AdditionalRules({ intl, countryCode, offer, lists }) {
	const excludedFromCommonRestrictionCountries = ['ID', 'HU', 'RO', 'TH', ...lists['regions-iso-codes'][0].id];

	const isMalePotencyOffer =
		['Normalization of male urogenital system', 'Normalization of sexual function'].includes(offer.category);

	const location = offer.locations.find((l) => l.country_code === countryCode);

	return (
		<div className="stream-form__stream-rules">
			<div>
				{intl('Сохраняя поток вы автоматически соглашаетесь с указанными ниже правилами')}:
			</div>
			<div>
				<div className='stream-form__stream-rule'>
					{intl('Таргет: от 35+ лет (строго)').replace('35', isMalePotencyOffer && isEverad ? '45' : '35')};
				</div>
				<div className='stream-form__stream-rule'>
					{intl('Подход: медицинское исследование, новостной формат, личная история и решении проблем')};
				</div>
				<div className='stream-form__stream-rule'>
					{intl('Придерживание форм-фактора продукта при продвижении РК, в частности на лендинге/прелендинге')};
				</div>
				<div className='stream-form__stream-rule'>
					{intl('Соблюдение ценовой политики на промо-материалах, в рамках запусков РК')}.
				</div>
			</div>
			{['ID', 'HU', 'RO', 'TH'].includes(countryCode) && (
				<div>
					<b>{intl('Запрещено')}:</b>
				</div>
			)}
			{!excludedFromCommonRestrictionCountries.includes(countryCode) && (
				<div>
					<br/>
					<br/>
					<b>{intl('Запрещено')}:</b>
					<br/>
					{intl('campaign-rule-common-1')}
				</div>
			)}
			{countryCode === 'ID' && (
				<div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-id-1')}
					</div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-id-2')}
					</div>
				</div>
			)}
			{countryCode === 'HU' && (
				<div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-hu-1')}
					</div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-hu-2')}
					</div>
				</div>
			)}
			{countryCode === 'RO' && (
				<div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-ro-1')}
					</div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-ro-2')}
					</div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-ro-3')}
					</div>
				</div>
			)}
			{countryCode === 'TH' && (
				<div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-th-1')}
					</div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-th-2')}
					</div>
					<div className='stream-form__stream-rule'>
						{intl('campaign-rule-th-3')}
					</div>
				</div>
			)}
			{['SA', 'JO', 'BH'].includes(countryCode) && [
				<div key={1}>
					{intl('Строго запрещено использовать в промо-материалах:')}
				</div>,
				<div key={2}>
					{[
						'Фотографии и надписи, которые могут оскорбить ценности ислама;',
						'Упоминания Бога и Аллаха прямо или косвенно, отсылка к Корану;',
						'Использование любой религиозной символики;',
						'Любые слова связанные с магией и потусторонними силами;',
						'Упоминания правящей власти, политический деятелей, элиты и армии;',
						'Упоминания и фото реальных звезд, известных личностей;',
						'Упоминания реальных врачей (их фото, имена), слов «врач», «лечить», «лекарство»;',
						'Информацию о Структуре здравоохранения и любых других Госструктур;',
						'Копирование официальных сайтов известных новостных порталов без изменений;',
						'Описывать/упоминать свойства, которые не обозначены на упаковке товара;',
						'Использовать фото эротического характера (обнаженные фото, части тела и тд);',
						'В Иордании строго запрещено упоминание растения «кропива» в изображениях и тексте.'
					].map((rule, i) => (
						<div className='stream-form__stream-rule' key={i}>
							{intl(rule)}
						</div>
					))}
				</div>,
				<div
					dangerouslySetInnerHTML={{ __html: intl('Нарушение любого из пунктов ...') }}
					key={3}
				/>
			]}
			<div>
				*{intl('для согласования индивидуальных промоматериалов обратитесь к своему персональному менеджеру')}
			</div>
			<div>
				<i>{intl('campaign-rule-common-2')}</i>
			</div>

			{!isEverad && location && location.location_restrictions && (
				<div>
					<b>{intl('Заявки не принимаются из следующих регионов')}:</b> {location.location_restrictions}
				</div>
			)}
		</div>
	);
}

export default withIntl(AdditionalRules);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/stream-form/additional-rules.js